import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetStore } from "app/actions";
import { fetchScores } from "app/thunks/scoresAPI";
import { Scores } from "interfaces/Score";

import { RootState } from "../store";

export interface State {
  list: {
    historical?: Scores[];
    last30days?: Scores[];
    daily?: Scores[];
    lastMatch?: Scores[];
  };
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
}

const initialState: State = {
  list: {
    historical: [],
    last30days: [],
    daily: [],
    lastMatch: [],
  },
  isFetching: false,
  isSuccess: false,
  isError: false,
};

export const scoresSlice = createSlice({
  name: "scores",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isSuccess = false;
      state.isFetching = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetStore, () => initialState)
      .addCase(fetchScores.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchScores.rejected, (state) => {
        state.isFetching = false;
        state.isError = true;
      })
      .addCase(fetchScores.fulfilled, (state, action: PayloadAction<any>) => {
        state.isSuccess = true;
        state.isFetching = false;
        state.list.historical = action.payload.historical;
        state.list.last30days = action.payload.last30days;
        state.list.daily = action.payload.daily;
        state.list.lastMatch = action.payload.lastMatch;
      });
  },
});

export const { resetFlags } = scoresSlice.actions;

// ------ Selectors ------
export const getScores = (state: RootState) => ({
  scores: state.scores.list,
  isFetching: state.scores.isFetching,
});

export default scoresSlice.reducer;
